import { ActionReducerMap } from '@ngrx/store';
import { balanceReducer, BalanceState } from './pay-with-points.reducers';

export interface PayWithPointsState {
  balance: BalanceState;
}

export const payWithPointsReducers: ActionReducerMap<PayWithPointsState> = {
  balance: balanceReducer,
};
